import { COMMON } from "constants/types";

const initState = {
  isShopLoading: false,
  productInfo: {},
  generalInfo: {},
  groupInfo: {},
  paymentLink: {},
  products: [],
  theme: {},
  hasPermissions: true,
  groupIsNotFound: false,
  productIsNotFound: false,
  isCustomDomain: false,
  isAdditionalDomain: false,
  feedback: [],
  bundles: [],
  invoice: {},
}


const CommonReducer = (state = initState, action) => {
  const { type, payload } = action;


  switch(type){

    case COMMON.START_LOADING:
      return {
        ...state,
        isShopLoading: true,
      }

    case COMMON.IS_ADDITIONAL_DOMAIN:
      return {
        ...state,
        isAdditionalDomain: action.payload || true,
      }

    case COMMON.IS_CUSTOM_DOMAIN:
      return {
        ...state,
        isCustomDomain: action.payload || true,
      }

    case COMMON.END_LOADING:
      return {
        ...state,
        isShopLoading: false,
      }

    case COMMON.GENERAL_SHOP_INFO:
      return {
        ...state,
        generalInfo: Object.assign({}, payload.shop),
        theme: Object.assign({}, payload.shop.theme),
        categories: payload.categories,
        items: payload.items,
        subscription: payload.subscription
      }

    case COMMON.SHOP_FEEDBACK:
      return {
        ...state,
        feedback: payload.feedback
      }

    case COMMON.GET_PRODUCT_BY_ID:
      return {
        ...state,
        productInfo: payload || {},
      }

    case COMMON.GET_GROUP_BY_ID:
      // private: product.private,
      //   unlisted: product.unlisted,
      let groupInfo = payload;
      if(groupInfo && groupInfo.products_bound && groupInfo.products_bound.length) {
        groupInfo = {
          ...groupInfo,
          products_bound: groupInfo.products_bound.filter((p) => {
            if(!p.private || !p.unlisted) {
              return p;
            }
          })
        }
      }
      return {
        ...state,
        groupInfo,
      }


    case COMMON.GET_INVOICE_BY_ID:
      return {
        ...state,
        invoice: payload,
      }

    case COMMON.GET_PAYMENT_LINK_BY_ID:
      return {
        ...state,
        paymentLink: payload.payment_link,
        products: payload.products,
      }


    case COMMON.CLEAR_SHOP_STATE:
      return {
        ...state,
        shopIsNotFound: false,
        shopIsBanned: false,
        shopIsOffline: false,
        shopIsExpired: false,
        pageNotFound: false,
      }

    case COMMON.SHOP_NOT_FOUND:
      return {
        ...state,
        shopIsNotFound: payload
      }

    case COMMON.PRODUCT_NOT_FOUND:
      return {
        ...state,
        productIsNotFound: payload
      }

    case COMMON.GROUP_NOT_FOUND:
      return {
        ...state,
        groupIsNotFound: payload
      }

    case COMMON.ADD_BUNDLE:
      return {
        ...state,
        bundles: payload
      }

    case COMMON.SHOP_BANNED:
      return {
        ...state,
        shopIsBanned: payload
      }

    case COMMON.SHOP_IS_OFFLINE:
      return {
        ...state,
        shopIsOffline: payload
      }


    case COMMON.SHOP_EXPIRED:
      return {
        ...state,
        shopIsExpired: payload
      }

    case COMMON.SHOP_REDIRECTED:
      return {
        ...state,
        shopIsRedirected: payload
      }

    case COMMON.SET_PERMISSION:
      return {
        ...state,
        hasPermissions: payload
      }

    default:
        return state
  }
}

export default CommonReducer